import { DateField, Edit, SimpleForm, TextField, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';

export const DeviceEdit = (props: unknown) => (
  <Edit {...props} title={<CustomTitle />}>
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="token" />
      <DateField source="createdate" showTime />
      <DateField source="lastupdate" showTime />
    </SimpleForm>
  </Edit>
);
